var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1 class=\"fm-garamind-headline\">Thanks for your interest in Artsy.<br>How may we help you?</h1><nav class=\"small-chevron-list fm-multiple-choice\"><a data-answer=\"auction\">I have an auction-related question.</a><a data-answer=\"artist\">I’m an artist interested in listing my work.</a><a data-answer=\"collector\">I’m an individual interested in selling artwork.</a><a data-answer=\"press\">I have a press inquiry.</a><a data-answer=\"feedback\">I have another question.</a></nav>");;return buf.join("");
};
module.exports = template;